
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Luciole'
  },
  /**
   * color for layer buttons and button to open settings
   */
  buttonSettingIcon: {
    backgroundColor: '#FFFFFF',
    backgroundActiveColor: '#0D58A6',
    contrastText: '#000000',
    contrastTextActive: '#FFFFFF',
    contrastTextSettings: '#0D58A6',
  },
  /**
   * color for card of road details and road step
   */
  cardRoadStep: {
    backgroundColor: '#FFFFFF',
    backgroundActiveColor: '#F4F5FF',
    borderCard: '#CACFD2',
    borderCardActive: '#0D58A6'
  },
  /**
   * color for selection of profile and condition
   */
  select: {
    main: '#FFFFFF',
    backgroundIcon: '#0D58A6',
    icon: '#FFFFFF'
  },
  /**
   * color of label of input (address, profile, condition, point and transport)
   */
  inputLabel: {
    color: '#FFFFFF',
    text: '#FFFFFF'
  },
  /**
   * color of icon MenuItem in selection of Profile
   */
  iconMenuItem: {
    background: '#0D58A6',
    backgroundActive: '#FFFFFF',
    border: '#FFFFFF',
    icon: '#FFFFFF',
    iconActive: '#0D58A6',
    iconBackground: 'transparent'
  },
  /**
   * color of text MenuItem in selection of Condition
   */
  textMenuItem: {
    background: '#0D58A6',
    backgroundActive: '#FFFFFF',
    color: '#FFFFFF',
    colorActive: '#0D58A6'
  },
  /**
   * color of button depart / arrive in selectedDetailsFeature
   */
  buttonItinFeature: {
    background: '#FFFFFF',
    backgroundHover: '#767676',
    color: '#0D58A6',
    colorHover: '#FFFFFF'
  },
  /**
   * color of feature label
   */
  accessibilityItems: {
    colorLabel: '#0D58A6',
  },
  palette: {
    common: {
      hover: '#797676',
      texthover: '#FFFFFF'
    },
    primary: {
      main: '#0D58A6',
      contrastText: '#FFFFFF',
      contrastBackground: '#FFFFFF',
      contrastBorder: '#FFFFFF'
    },
    contrastprimary: {
      main: '#FFFFFF',
      contrastText: '#0D58A6',
    },
    secondary: {
      main: '#558ac0',
      contrastText: '#FFFFFF',
      contrastBorder: '#0D58A6'
    },
    modal: {
      main: '#172370'
    },
    buttonSettings: {
      main: '#FFFFFF',
      contrastText: '#0D58A6',
    },
    /**
     * color of border of selection of map type
     */
    mapTypeActive: {
      main: '#0D58A6',
    },
    mapTypeNonActive: {
      main: '#A9A9A9'
    },
    zone: {
      main: '#0D58A6',
      contrastText: '#FFFFFF',
      contrastBackground: '#FFFFFF',
      contrastBorder: '#FFFFFF'
    },
  }
});

export default theme;